const root = (process.env.NODE_ENV !== 'production' ? "localhost:3000" : process.env.REACT_APP_DOMAIN);
const ssl = (process.env.NODE_ENV !== 'production' ? false : (process.env.REACT_APP_SSL === "true"));
const path = (() => {switch (process.env.REACT_APP_SERVER_TYPE)
{
    case 'localhost':
        return 'rayman';
    case 'development':
    default:
        return 'dev';
    case 'production':
        return 'v1';
    case 'demo':
        return 'demo';
}})();

const config = {
    connections:
    {
        apiURL: `${ssl ? "https" : "http"}://${root}/${path}/api/`,
        notificationsSocketURL: `${process.env.REACT_APP_SSL === "true" ? "wss" : "ws"}://${process.env.REACT_APP_DOMAIN}/${path}/sockets/notifications`,
        signalingSocketURL: `${process.env.REACT_APP_SSL === "true" ? "wss" : "ws"}://${process.env.REACT_APP_DOMAIN}/${path}/sockets/signaling`,
    },
    domain: process.env.REACT_APP_DOMAIN,
    server: process.env.REACT_APP_SERVER_TYPE
};

Object.freeze(config);
Object.freeze(config.connections);

export default config;